import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../utils/services/api.service';
import {ActivatedRoute} from '@angular/router';
import {BSModalContext} from 'ngx-modialog/plugins/bootstrap';
import {Modal, overlayConfigFactory} from 'ngx-modialog';
import {DomainInfoComponent} from '../domain-info/domain-info.component';
import {Domain} from '../../../utils/objects/organization';
import {NotificationsService} from 'angular2-notifications';

@Component({
  selector: 'app-domains',
  templateUrl: './domains.component.html',
  styleUrls: ['./domains.component.css']
})
export class DomainsComponent implements OnInit {

  public domains: Array<Domain>;
  private organizationID: number;

  constructor(public modal: Modal,
              private apiService: ApiService,
              private activatedRoute: ActivatedRoute,
              private notificationsService: NotificationsService) {
  }

  ngOnInit() {
    this.organizationID = this.activatedRoute.snapshot.parent.params.id;
    this.apiService.getOrganizationDomains(this.organizationID).subscribe(
      response => {
        this.domains = response['data'].rows;
      }, error => {
        this.domains = [];
      }
    );
  }

  deleteDomain(domain: Domain) {
    this.apiService.deleteOrganizationDomain(this.organizationID, domain.id).subscribe(
      response => {
        this.notificationsService.success('Success', 'Domain is deleted');
        this.domains.splice(this.domains.findIndex((el) => el.id === domain.id), 1);
      }, error => {
        this.notificationsService.error('Error', 'Error occured');
      }
    );

  }

  addorEditDomain(domain: Domain) {
    let dialogRef = this.modal.open(
      DomainInfoComponent,
      overlayConfigFactory({
        size: 'lg',
        organizationID: this.organizationID,
        domain: domain
      }, BSModalContext));

    dialogRef.result.then((result) => {
      switch (result.type) {
        case 'ADDED':
          this.domains.push(result.data);
          break;
        case 'UPDATED':
          this.domains[this.domains.findIndex((domain) => domain.id === result.data.id)].domain = result.data.domain;
          break;
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/frames/domains/domains.component.ts